import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "content-container order-content" }
const _hoisted_2 = { key: "boolean" }
const _hoisted_3 = {
  key: 0,
  class: "grid collapse-columns"
}
const _hoisted_4 = { class: "information" }
const _hoisted_5 = { class: "key" }
const _hoisted_6 = {
  key: 0,
  class: "value"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "grid collapse-columns"
}
const _hoisted_9 = { class: "information" }
const _hoisted_10 = { class: "signature" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_base_panel = _resolveComponent("base-panel")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_VueSignaturePad = _resolveComponent("VueSignaturePad")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "page-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: "ionic-header ion-no-border",
        mode: "ios",
        "no-border": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            class: "toolbar",
            mode: "ios",
            "no-padding": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    icon: _ctx.BackIcon,
                    "default-href": "/",
                    text: ""
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "none",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
                          fill: "black"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "title" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Accorderen ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-content-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_1, [
            _createVNode(_Transition, {
              mode: "out-in",
              name: "hide-panel"
            }, {
              default: _withCtx(() => [
                (_ctx.orderHasChanged === null)
                  ? (_openBlock(), _createBlock(_component_base_panel, { key: "null" }, {
                      content: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("h3", null, "Is er wat veranderd?", -1),
                        _createElementVNode("div", { class: "information" }, [
                          _createElementVNode("p", null, "Ten opzichte van de originele installatie informatie.")
                        ], -1)
                      ]))]),
                      cta: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "cta",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.orderInformationChanged(true)))
                        }, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("span", { class: "cta-text" }, " Ja ", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "cta",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.orderInformationChanged(false)))
                        }, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("span", { class: "cta-text" }, " Nee ", -1)
                        ]))])
                      ]),
                      _: 1
                    }))
                  : (_ctx.orderHasChanged === true || _ctx.orderHasChanged === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_base_panel, null, {
                          content: _withCtx(() => [
                            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Installatie informatie", -1)),
                            _createVNode(_Transition, { name: "fade" }, {
                              default: _withCtx(() => [
                                (_ctx.orderHasChanged === false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.installation_information, (informationItem, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "column"
                                        }, [
                                          _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(informationItem.key), 1),
                                            (informationItem.options.length === 0)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(informationItem.value), 1))
                                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(informationItem.options, (option, index) => {
                                                  return (_openBlock(), _createElementBlock("p", {
                                                    key: `option-${index}`,
                                                    class: "value"
                                                  }, [
                                                    (option.value === informationItem.value)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(option.label), 1))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                }), 128))
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : ( _ctx.orderHasChanged === true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.installation_information, (informationItem, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: `information-item-${index}-${informationItem.key}`,
                                            class: "column"
                                          }, [
                                            _createElementVNode("div", _hoisted_9, [
                                              _createVNode(_component_ion_label, { class: "select-label" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(informationItem.key), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              (informationItem.options.length > 0)
                                                ? (_openBlock(), _createBlock(_component_ion_select, {
                                                    key: 0,
                                                    modelValue: informationItem.value,
                                                    "onUpdate:modelValue": ($event: any) => ((informationItem.value) = $event),
                                                    disabled: informationItem.options.length === 0,
                                                    "interface-options": _ctx.selectInterfaceOptions,
                                                    placeholder: informationItem.value,
                                                    class: "select-value",
                                                    interface: "popover",
                                                    mode: "ios",
                                                    onIonChange: _ctx.clearCanvas
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(informationItem.options, (installationOption, index) => {
                                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                          key: index,
                                                          value: installationOption.value
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(installationOption.label), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "interface-options", "placeholder", "onIonChange"]))
                                                : _createCommentVNode("", true),
                                              (informationItem.options.length === 0)
                                                ? (_openBlock(), _createBlock(_component_ion_input, {
                                                    key: 1,
                                                    modelValue: informationItem.value,
                                                    "onUpdate:modelValue": ($event: any) => ((informationItem.value) = $event),
                                                    placeholder: informationItem.value,
                                                    class: "select-value",
                                                    onIonChange: _ctx.clearCanvas
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onIonChange"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_base_panel, null, {
                          content: _withCtx(() => [
                            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Accorderen", -1)),
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "information" }, [
                              _createElementVNode("p", null, "Als je akkoord bent met de installatie van de Waterontharder, zet dan binnen het onderstaande vak jouw handtekening.")
                            ], -1)),
                            _createElementVNode("div", _hoisted_10, [
                              (!_ctx.order.is_finished)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn-circular ion-activatable ripple-parent",
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearCanvas && _ctx.clearCanvas(...args)))
                                  }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("svg", {
                                      class: "icon",
                                      fill: "fill",
                                      viewBox: "0 0 24 24",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                      _createElementVNode("path", {
                                        d: "M17 8.00714L15.9929 7L12 10.9929L8.00714 7L7 8.00714L10.9929 12L7 15.9929L8.00714 17L12 13.0071L15.9929 17L17 15.9929L13.0071 12L17 8.00714Z",
                                        fill: "fill"
                                      })
                                    ], -1)),
                                    _createVNode(_component_ion_ripple_effect)
                                  ]))
                                : _createCommentVNode("", true),
                              (!_ctx.order.is_finished)
                                ? (_openBlock(), _createBlock(_component_VueSignaturePad, {
                                    key: 1,
                                    ref: "signaturePad",
                                    height: 160,
                                    options: _ctx.signatureOptions,
                                    width: 370,
                                    class: "signature-pad"
                                  }, null, 8, ["options"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("img", {
                                src: _ctx.order.signature_url
                              }, null, 8, _hoisted_11)
                            ]),
                            (!_ctx.order.is_finished)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  disabled: _ctx.signatureEmpty,
                                  class: "btn full-width",
                                  color: "primary",
                                  expand: "block",
                                  shape: "round",
                                  onClick: _ctx.toPayment
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.totalPrice > 0 ? 'Naar betalen' : 'Afspraak afronden'), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}